<template>
    <configured-layout
        title="Select Powertrain"
        :breadcrumbs="breadcrumbs"
        next-title="Next Step | Color"
        @next="onNext"
    >
        <options-list :options="powertrainOptions" />
    </configured-layout>
</template>

<script>
import _ from "lodash";
import { get } from "vuex-pathify";
import ConfiguredLayout from "./components/Layout";
import OptionsList from "Modules/Configure/components/OptionsList";
import loader from "Modules/Configure/mixins/loader";

export default {
    components: {
        OptionsList,
        "configured-layout": ConfiguredLayout
    },

    mixins: [loader],

    props: {
        styleId: {
            required: true,
            type: String
        }
    },

    computed: {
        loading: get("configure/loading"),
        powertrainOptions: get("configure/powertrainOptions"),
        breadcrumbs() {
            return [
                {
                    text: this.vehicleName,
                    href: this.vehicleDetailsUrl
                },
                {
                    text: "Select Powertrain",
                    active: true
                }
            ];
        }
    },

    watch: {
        loading(newVal) {
            if (!newVal && _.size(this.powertrainOptions) === 0) {
                this.$router.replace({ name: "color" });
            }
        }
    },

    mounted() {
        if (!this.loading && _.size(this.powertrainOptions) === 0) {
            this.$router.replace({ name: "color" });
        }
    },

    methods: {
        onNext() {
            this.$router.push({ name: "color" });
        }
    }
};
</script>
